<template>
  <div v-if="hasCards">
    <v-card @click="getCardsByContentIdClick()" flat class="pa-0 ma-0 mr-3">
      <v-row align="center" justify="center" class="pa-0 ma-0 vetalfa-row">
        <v-icon size="26" color="primary">{{ _icon("flashcardsIcon") }}</v-icon>
      </v-row>
    </v-card>
    <vetalfa-flash-cards></vetalfa-flash-cards>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Flashcards from "@/components/Flashcards.vue";
export default {
  name: "FlashcardsButton",
  components: {
    "vetalfa-flash-cards": Flashcards,
  },
  methods: {
    ...mapActions("preferences", ["getCardsByContentId", "getSearchList"]),
    getCardsByContentIdClick() {
      this.getCardsByContentId(this.targetItem.id.replace("treatment&", ""));
    },
  },
  computed: {
    ...mapGetters("drugs", ["drug"]),
    ...mapGetters("topics", ["item"]),
    ...mapGetters("preferences", ["searchList"]),
    targetItem() {
      return this.$route.name === "drugs" ? this.drug : this.item;
    },
    hasCards() {
      if (!this.searchList || ["clinical-handouts-content"].includes(this.$route.name)) return false;
      return this.searchList.find(
        (item) =>
          this.targetItem &&
          item.id === this.targetItem.id.replace("treatment&", "") &&
          !!item.card
      );
    },
  },
  created() {
    if (!this.searchList) {
      this.getSearchList();
    }
  },
};
</script>